module.exports = "./img/desktop_logo.ee61ddc.png";